<template>
  <div>
    <!-- Trigger Icon or Selected Date -->
    <div @click="openDialog" style="cursor: pointer;">
      <span v-if="!modelValue">🔍</span>
      <template v-else>
        <div class="flex items-center justify-center w-date text-xs flex-col">
          <div>{{ $moment(modelValue).format("YYYY") }}</div>
          <div>{{ $moment(modelValue).format("MM") }}</div>
        </div>
      </template>
    </div>

    <!-- Custom Dialog -->
    <div v-if="showDialog" class="custom-dialog-overlay" @click.self="closeDialog">
      <div class="custom-dialog">
        <!-- Dialog Header -->
        <div class="custom-dialog-header">
          <h3>{{ title }}</h3>
          <button class="close-btn" @click="closeDialog">✖</button>
        </div>

        <!-- Date Picker -->
        <div class="custom-dialog-body">
          <Datepicker
              v-model="internalValue"
              month-picker
              auto-apply
              format="yyyy-MM"
              locale="ja"
              :enable-time-picker="false"
          />
        </div>

        <!-- Dialog Footer -->
        <div class="custom-dialog-footer">
          <button class="cancel-btn" @click="onCancel">キャンセル</button>
          <button class="ok-btn" @click="onConfirm">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default {
  name: "YearMonthPickerDialog",
  components: {
    Datepicker,
  },
  props: {
    modelValue: {
      type: [String, Date, null, Object],
      default: null,
    },
    title: {
      type: String,
      default: "月を選択",
    },
  },
  data() {
    return {
      showDialog: false,
      internalValue: this.modelValue,
    };
  },
  watch: {
    modelValue(newValue) {
      this.internalValue = newValue;
    },
  },
  methods: {
    openDialog() {
      this.showDialog = true;
      this.internalValue = this.modelValue;
    },
    closeDialog() {
      this.showDialog = false;
    },
    onCancel() {
      this.internalValue = null;
      this.$emit("update:modelValue", null);
      this.closeDialog();
    },
    onConfirm() {
      this.$emit("update:modelValue", this.internalValue);
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
/* Dialog Overlay */
.custom-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 11000;
}

/* Dialog Box */
.custom-dialog {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  width: 350px;
  max-width: 90%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.3s ease-in-out;
}

/* Dialog Header */
.custom-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.custom-dialog-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

/* Dialog Body */
.custom-dialog-body {
  margin: 15px 0;
}

/* Dialog Footer */
.custom-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn,
.ok-btn {
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn {
  background: #e74c3c;
  color: #fff;
}

.ok-btn {
  background: #2ecc71;
  color: #fff;
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
